<template>
  <div v-if="Object.keys(filterOptions).length" ref="filterModule" class="cf__item" :class="[{'cf__item--active': filterType === 'category'}]" >
    <div class="cf__title-wrapper" @click="toggleFilterModule">
      <div class="cf__title">By 
        <span class="cf__title-type">{{ filterType }}</span>
        <span v-if="checkedOptions.length">({{checkedOptions.length}})</span>
      </div>
      <svg :class="['cf__icon']">
        <use xlink:href="#caret-down"></use>
      </svg>
    </div>
    <ul class="cf__options">
      <li v-for="(count,name) in filterOptions" :key="name" class="cf__option">
        <label>
          <input
            class="hide"
            type="checkbox" 
            :value="name" 
            :id="name"
            :checked="checkedOptions.some(option => isEqual(option, name))"
            @change="e => updateCheckedInput(e,filterType,name)"
          >
          <svg v-if="!checkedOptions.some(option => isEqual(option, name))" class="icon icon--md"><use href="#checkbox-empty"></use></svg>
          <svg v-else class="icon icon--md checked"><use href="#check-contained-filled"></use></svg>
          <span class="text-base">{{name}} {{`(${count})`}}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script setup>
  import {ref, toRefs, computed, onMounted, watch} from 'vue';
  import isEqual from 'lodash/isEqual';

  const props = defineProps({
    filterType: {
      type: String,
      required: true,
    },

    filterOptions: {
      type: Array,
      required: true,
    },

    appliedFilters: {
      type: Object,
      required: true,
    }
  })

  const { filterType, filterOptions, appliedFilters } = toRefs(props)
  const filterModule = ref(null)
  const checkedOptions = ref([])
  const emit = defineEmits(['input-change'])

  onMounted(() => {
    if(appliedFilters.value){
      checkedOptions.value = appliedFilters.value
    }
  })

  const toggleFilterModule = () => {
    filterModule.value.classList.toggle('cf__item--active')
  }

  const updateCheckedInput = (event,type,option) => {
    if (event.target.checked) {
      checkedOptions.value = [...checkedOptions.value, option]
    }else {
      checkedOptions.value = checkedOptions.value.filter(
        checkedOption => !isEqual(checkedOption, option)
      )
    }

    window.initYotpoData();

    emit('input-change',type,checkedOptions.value)
  }

  watch(appliedFilters, (value) => {
    const newCheckedOptions = value || []

    if (!isEqual(checkedOptions.value, newCheckedOptions)) {
      checkedOptions.value = newCheckedOptions
    }
  })
</script>